import { IAttribute, IModel } from 'app/model/base/annotation';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

export const ATTIO_APP_MODEL_VERSION = '1.0';
export const ATTIO_RUNTIME_VERSION = '1.1.0.0';
export const ATTIO_AUTHENTICATION_TYPE = 'Key';

@Metamodel.model({
    name: 'Attio',
    display: []
})
export class AttioLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly ACCESS_TOKEN: IAttribute;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version: string = ATTIO_APP_MODEL_VERSION;

    @Metamodel.attribute({
        display: stringResources.DriverVersion
    })
    public sideBySideConnectorVersion: string = ATTIO_RUNTIME_VERSION;

    @Metamodel.attribute({
        display: stringResources.ModelName_Url,
        association: 'URL',
        templatable: true
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.Authentication
    })
    public authentication: string = ATTIO_AUTHENTICATION_TYPE;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        association: 'ACCESS_TOKEN',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;
}
